function init($el, modulesObjects) {
    var modules = null;

    if ($el.data('modules')) {
        modules = $el.data('modules').split(',');
    } else {
        modules = [
            'CKEditor', 
            'InputsCheckboxesRadios', 
            'ExtendedFormControls', 
            'InputsBasic', 
            'Select2Selects', 
            'Forms', 
            'FullCalendarBasic',
            'JqueryUiForms', 
            'JqueryUiSliders', 
            'ColorPicker', 
            'DateTimePickers', 
            'Search', 
            'Locations'
        ];
    }
         
    $el.icubeCloner({
        _afterInit: function($container, $clonerObject, currentIteration) {},
        _afterClone: function($container, $clonerObject, currentIteration) {
            $.each(modules, function(index, moduleName) {
                modulesObjects[moduleName].init($container);
            });
        }
    });   
}

export const GlobalCloner = {
    init
}